import { Routes } from '@angular/router';

import {
    AuthGuardService as AuthGuard,
    PrebuyGuardService as PrebuyGuard,
    BingoTournamentsGuardService as TournamentsGuard,
} from '@frontend/bingo/ui-lib/shared';
import { routeData } from '@frontend/vanilla/core';

import { ConfigResolver } from './resolver/config-resolver.component';

export const BINGO_INTERNAL_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('./main/main.component').then((c) => c.MainComponent),
        resolve: {
            config: ConfigResolver,
        },
        data: routeData({ allowAnonymous: true }),
        children: [
            {
                path: '',
                loadComponent: () => import('./home/home.component').then((c) => c.HomeComponent),
                resolve: {
                    config: ConfigResolver,
                },
                data: { Home: 'true' },
            },
            {
                path: 'prebuy',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.TicketsComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'forcedgamelaunch/:gameName',
                loadComponent: () => import('./force-redirect/game-redirect.component').then((c) => c.GameRedirectComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'forcedprebuy',
                loadComponent: () => import('./force-redirect/pre-buy-redirect.component').then((c) => c.PrebuyRedirectComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'forcedfavourite',
                loadComponent: () => import('./force-redirect/favourite-redirect.component').then((c) => c.FavouriteRedirectComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'menu/launchroom/:roomid',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: 'all',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'menu/mytickets',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'menu/mytickets/games-info/:roomid',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: 'all',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'menu/prebuy',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/:ballType/games-info/:room-name',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/games-info/:room-name',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: 'schedule',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/games-info/:room-name',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/90-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '90-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/80-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '80-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/75-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '75-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/50-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '50-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/40-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '40-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/30-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '30-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule/36-ball',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: '36-ball',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'schedule',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: 'all',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'myfavourites',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                resolve: {
                    config: ConfigResolver,
                },
                canActivate: [AuthGuard],
            },
            {
                path: 'sessionbingo',
                resolve: {
                    config: ConfigResolver,
                },
                canActivate: [PrebuyGuard],
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.SessionBingoComponent),
            },
            {
                path: 'bingotournaments',
                resolve: {
                    config: ConfigResolver,
                },
                canActivate: [TournamentsGuard],
                loadComponent: () => import('@frontend/bingo/frontend-lib/bingo-tournaments').then((m) => m.BingoSlotRacesWrapperComponent),
            },
            {
                path: 'packagebingo',
                resolve: {
                    config: ConfigResolver,
                },
                canActivate: [PrebuyGuard],
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((m) => m.PackagesContainerComponent),
            },
            {
                path: 'sessionpopup',
                resolve: {
                    config: ConfigResolver,
                },
                canActivate: [PrebuyGuard],
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((m) => m.BuyNowGridComponent),
            },
            {
                path: 'schedule/gameIframelauncher',
                loadComponent: () => import('./game-Iframe-launcher/game-Iframe-launcher.component').then((c) => c.GameIframeLauncherComponent),
                data: {
                    roomId: 'gameIframeLauncher',
                },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'games/:categoryId',
                loadComponent: () => import('./casino-category/casino-category.component').then((c) => c.CasinoCategoryComponent),
            },
            {
                path: 'rooms',
                loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                data: {
                    roomId: 'all',
                },
                resolve: {
                    config: ConfigResolver,
                },
                children: [
                    {
                        path: '90-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '90-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '80-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '80-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '75-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '75-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '50-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '50-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '40-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '40-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '30-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '30-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: '36-ball',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        data: {
                            roomId: '36-ball',
                        },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: ':ballType/games-info/:room-name',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: 'games-info/:room-name',
                        loadComponent: () => import('@frontend/bingo/ui-lib/shared').then((c) => c.RoomsListComponent),
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                ],
            },
            {
                path: 'search',
                resolve: {
                    config: ConfigResolver,
                },
                loadComponent: () => import('./search/search.component').then((c) => c.SearchComponent),
            },
            {
                path: 'casinosidepane',
                resolve: {
                    config: ConfigResolver,
                },
                loadComponent: () => import('./casino-side-pane/casino-side-pane.component').then((c) => c.CasinoSidePaneComponent),
            },
            {
                path: 'bingowidget/cozybingo',
                loadComponent: () => import('./BingoWidget/bingo-widget.component').then((c) => c.BingoWidgetComponent),
                resolve: {
                    config: ConfigResolver,
                },
            },
        ],
    },
];
